module.exports = __webpack_public_path__ + "assets/img/xs_info.89678b23.png";